import React from "react";
import { Switch, Route } from "react-router-dom";
import Authorization from "../../components/Authorization";

import EmployeeRouter from "./Employees";
import DrugTestCategoryRouter from "./DrugTestCategories";
import DrugTestRouter from "./DrugTests";
import CertificationRouter from "./Certifications";

const PayMgmnt = Authorization(["ADMIN", "HR"], ["DISP"]);

const HRManagementRouter = () => (
  <Switch>
    <Route path="/hr/employees">{PayMgmnt(EmployeeRouter)}</Route>
    <Route path="/hr/drug-test-categories">
      {PayMgmnt(DrugTestCategoryRouter)}
    </Route>
    <Route path="/hr/drug-tests/:id?">{PayMgmnt(DrugTestRouter)}</Route>
    <Route path="/hr/certifications">
      {Authorization(["ADMIN", "HR"], ["MGMNT"])(CertificationRouter)}
    </Route>
  </Switch>
);

export default HRManagementRouter;
